/* Black & Black FW27 — small progressive enhancements. Everything works without JS. */
(function () {
  // Close the mobile menu / dropdowns on Escape or outside click.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open].menu-drawer, details[open].dropdown').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[open].dropdown').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.querySelectorAll('[data-close-drawer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = btn.closest('details');
      if (d) d.removeAttribute('open');
    });
  });

  // Lock page scroll while the mobile menu is open.
  document.querySelectorAll('details.menu-drawer').forEach(function (d) {
    d.addEventListener('toggle', function () {
      document.documentElement.style.overflow = d.open ? 'hidden' : '';
    });
  });

  // Auto-submit selects marked data-autosubmit (sort, country).
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form && el.form.submit(); });
  });

  // Product page: show only the photos of the chosen colour.
  function filterGallery(chosen) {
    var g = document.querySelector('[data-gallery][data-color-index]');
    if (!g) return;
    var color = chosen[parseInt(g.dataset.colorIndex, 10)];
    var items = Array.prototype.slice.call(g.children).filter(function (el) { return el.classList.contains('media'); });
    if (!items.some(function (el) { return el.dataset.color === color; })) return;
    var max = parseInt(g.dataset.max, 10) || 12;
    var shown = 0;
    items.forEach(function (el) {
      var show = (el.dataset.color === color || el.dataset.color === '') && shown < max;
      if (show) shown++;
      el.hidden = !show;
    });
    var total = g.parentElement.querySelector('[data-gallery-total]');
    if (total) total.textContent = shown;
    var idx = g.parentElement.querySelector('[data-gallery-index]');
    if (idx) idx.textContent = 1;
    g.scrollTo({ left: 0 });
    if (window.innerWidth > 989) {
      var top = g.getBoundingClientRect().top + window.scrollY - 80;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  // Product: resolve variant from option pills (multi-option products).
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('[name="id"]');
    var button = form.querySelector('[data-add-button]');
    var price = document.querySelector('[data-product-price]');
    var labels = { add: button ? button.dataset.labelAdd : '', soldOut: button ? button.dataset.labelSoldout : '', unavailable: button ? button.dataset.labelUnavailable : '' };

    function update() {
      var chosen = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      filterGallery(chosen);
      if (!button) return;
      if (!match) {
        button.disabled = true; button.textContent = labels.unavailable; return;
      }
      idInput.value = match.id;
      button.disabled = !match.available;
      button.textContent = match.available ? labels.add : labels.soldOut;
      if (price && match.price_html) price.innerHTML = match.price_html;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', update);
  });
})();

/* Product cards: gallery arrows, colour swatches, quick add */
(function () {
  function slideBy(card, dir) {
    var track = card.querySelector('[data-card-slides]');
    if (!track) return;
    var w = track.clientWidth;
    var max = track.scrollWidth - w;
    var next = track.scrollLeft + dir * w;
    if (next > max + 2) next = 0;
    if (next < -2) next = max;
    track.scrollTo({ left: next, behavior: 'smooth' });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-product-card]');
    if (!card) {
      document.querySelectorAll('.quick-add.is-open').forEach(function (q) {
        q.classList.remove('is-open');
        var t = q.querySelector('[data-quick-add-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    if (e.target.closest('[data-card-prev]')) { e.preventDefault(); slideBy(card, -1); return; }
    if (e.target.closest('[data-card-next]')) { e.preventDefault(); slideBy(card, 1); return; }

    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      var qa = toggle.closest('[data-quick-add]');
      var open = !qa.classList.contains('is-open');
      qa.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var swatch = e.target.closest('[data-swatch]');
    if (swatch) {
      card.querySelectorAll('[data-swatch]').forEach(function (s) {
        var on = s === swatch;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var url = swatch.dataset.url;
      if (url) card.querySelectorAll('[data-card-slides], [data-card-link]').forEach(function (a) { a.href = url; });
      var color = swatch.dataset.color;
      var track = card.querySelector('[data-card-slides]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.product-card__slide')) : [];
      var grouped = slides.some(function (sl) { return sl.dataset.color === color; });
      if (grouped) {
        // Show this colour's photos (plus shared ones), up to the card's limit
        var max = parseInt(track.dataset.max, 10) || 4;
        var shown = 0;
        slides.forEach(function (sl) {
          var match = sl.dataset.color === color || sl.dataset.color === '';
          var show = match && shown < max;
          if (show) shown++;
          sl.hidden = !show;
          sl.classList.remove('is-lead');
        });
        var lead = slides.filter(function (sl) { return !sl.hidden; })[0];
        if (lead) lead.classList.add('is-lead');
      } else {
        // No photo grouping for this colour: swap the first photo for the variant photo
        var img = swatch.dataset.image;
        var first = track ? track.querySelector('img') : null;
        if (img && first) { first.srcset = ''; first.src = img; }
      }
      if (track) track.scrollTo({ left: 0 });
      card.querySelectorAll('.quick-add__size').forEach(function (b) { b.hidden = b.dataset.color !== color; });
    }
  });

  // Quick add via AJAX; falls back to a normal form post without JS.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var id = (btn && btn.name === 'id') ? btn.value : (form.querySelector('[name="id"]') || {}).value;
    if (!id) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (btn) { btn.innerHTML = '✓'; }
        setTimeout(function () {
          if (btn) { btn.innerHTML = label; btn.disabled = false; }
          var qa = form.closest('[data-quick-add]');
          if (qa) qa.classList.remove('is-open');
        }, 1200);
      })
      .catch(function () {
        if (!form.querySelector('input[name="id"]')) {
          var h = document.createElement('input'); h.type = 'hidden'; h.name = 'id'; h.value = id; form.appendChild(h);
        }
        form.submit();
      });
  });
})();

/* Product page gallery counter (mobile carousel) */
(function () {
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var out = g.parentElement.querySelector('[data-gallery-index]');
    if (!out) return;
    var tick = null;
    g.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = null;
        var i = Math.round(g.scrollLeft / Math.max(g.clientWidth, 1)) + 1;
        out.textContent = i;
      });
    }, { passive: true });
  });
})();
